import {useState,useEffect} from 'react';
import Hero from './EntryPage';
import { useLanguage } from '../i18n/LanguageContext';

import { useGenericEffect } from '../components/UseGenericEffect';
import TermsOfService from '../content/terms_of_service'; 
import PrivacyPolicy from '../content/privacy_policy';


export default function HowICanHelp() {
  const { strings } = useLanguage();

  

 

  return (
      <main>
          <div>
              <div >    
                  <div>
                  <h1>Terms of Service</h1>
                  <br/>
                  <TermsOfService lang={strings.lang_code}/>
                  <h1>Privacy Policy</h1>
                  <br/>
                  <PrivacyPolicy lang={strings.lang_code}/>
                  </div>       
              </div>
       </div>
      </main>

  );
}